module.exports = __webpack_public_path__ + "img/cost-icon__alberca_infinity.e89058fb.svg";